import { formatTime24to12 } from "@/lib/format";

// SEO content block for a game's Common Number page.
// Content is short but unique per game via {name}, {category}, timing.
export default function CommonNumberContent({ game }) {
  const fr = formatTime24to12(game.fr_time);
  const sr = formatTime24to12(game.sr_time);
  const cat = game.category.replace(" Results", "").replace(" Games", "");
  const shortName = game.name.replace(/\s*Teer$/i, "");

  return (
    <article className="mt-8 max-w-2xl mx-auto text-neutral-700 leading-relaxed text-[15px] sm:text-base space-y-5">
      <section>
        <h2 className="font-heading text-xl sm:text-2xl font-bold text-neutral-900">
          {game.name} Common Number Today
        </h2>
        <p className="mt-2">
          The {game.name} common number for today is auto-refreshed on this page every day. It is the same number
          shown to every visitor and updates automatically — <strong>8:00 PM IST for morning &amp; day Teer</strong>{" "}
          and <strong>1:00 AM IST for night Teer</strong> — so you can plan ahead. The card above shows the
          {" "}{game.name} common number as three simple values — Direct Number, House and Ending — for both the
          First Round (F/R) at {fr} IST and the Second Round (S/R) at {sr} IST.
        </p>
      </section>

      <section>
        <h3 className="font-heading text-lg font-bold text-neutral-900">
          How to read the {shortName} common number
        </h3>
        <ul className="mt-2 space-y-2 list-disc list-inside">
          <li>
            <strong>Direct Number</strong> — the main two-digit pick along with its reversed pair. Two picks are
            shown so you can spot both the direct number and its mirror.
          </li>
          <li>
            <strong>House</strong> — the first digit of the Direct Number, useful when only the tens position
            matters.
          </li>
          <li>
            <strong>Ending</strong> — the last digit of the Direct Number, useful when only the units position
            matters.
          </li>
        </ul>
      </section>

      <section>
        <h3 className="font-heading text-lg font-bold text-neutral-900">
          About {game.name}
        </h3>
        <p className="mt-2">
          {game.name} is part of the {cat} category tracked on Juwai Teer. Its First Round (F/R) is scheduled at
          {" "}{fr} IST and the Second Round (S/R) at {sr} IST. Every day this page updates automatically — you do
          not need to refresh manually. For the complete list of past outcomes, visit the {game.name} previous
          result page. For today's live F/R and S/R numbers, open the {game.name} result page.
        </p>
      </section>

      <section>
        <h3 className="font-heading text-lg font-bold text-neutral-900">
          Frequently asked
        </h3>
        <div className="mt-2 space-y-3">
          <div>
            <div className="font-semibold text-neutral-900">When does the {shortName} common number change?</div>
            <p>
          Every day the rollover happens automatically — 8:00 PM IST for morning &amp; day Teer and 1:00 AM IST
              for night Teer — and the page updates to the next day&apos;s common number.
            </p>
          </div>
          <div>
            <div className="font-semibold text-neutral-900">Is this the official {shortName} common number?</div>
            <p>
              No. Numbers displayed here are informational picks derived on this website for {game.name}. Please
              verify with your local {shortName} counter for anything official.
            </p>
          </div>
          <div>
            <div className="font-semibold text-neutral-900">Where can I see the actual {shortName} result?</div>
            <p>
              Once the F/R and S/R rounds are declared, the {game.name} result page shows the actual FR and SR
              numbers for the day, and the previous result page keeps the full history.
            </p>
          </div>
        </div>
      </section>

      <p className="text-xs text-neutral-500">
        Disclaimer: {game.name} common number content on this page is for informational purposes only. This website
        does not guarantee winnings and is not affiliated with any Teer counter.
      </p>
    </article>
  );
}
